import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { AutonumericModule } from '../../directives/autonumeric/autonumeric.module';
import { TooltipsModule } from '../../features/tooltip/tooltips.module';
import { FilterFieldNumbersInputComponent } from './filter-field-numbers-input.component';

@NgModule({
  declarations: [FilterFieldNumbersInputComponent],
  imports: [CommonModule, PipesModule, FormsModule, TooltipsModule, AutonumericModule],
  exports: [FilterFieldNumbersInputComponent],
})
export class FilterFieldNumberInputModule {}
